import React from "react";
import Box from "@mui/material/Box";

export default function CompanyLabelsLogo({ logoUrl }) {
  if (!logoUrl) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center">
      <Box
        component="img"
        src={logoUrl}
        alt="Company labels logo"
        sx={{ maxHeight: { xs: 30, md: 40 }, maxWidth: { xs: 100, md: 120 } }}
      />
    </Box>
  );
}
